export default function getTimeCode(timecode: number, shouldShowHours: boolean): string {
  const timeInMs = timecode * 1000
  const seconds = Math.floor((timeInMs / 1000) % 60)
  const minutes = Math.floor((timeInMs / (1000 * 60)) % 60)
  const hours = Math.floor((timeInMs / (1000 * 60 * 60)) % 24)

  const formattedMinutes = (minutes < 10) ? `0${minutes}` : minutes.toString()
  const formattedSeconds = (seconds < 10) ? `0${seconds}` : seconds.toString()

  return shouldShowHours ? `${hours}:${formattedMinutes}:${formattedSeconds}` : `${formattedMinutes}:${formattedSeconds}`
}
